import React from "react";
import { Button, Form, Flex, Row, Col, InputNumber } from "antd";
import { useForm } from "antd/es/form/Form";

import { RequestAtc } from "../redux/apiSlice/requestSlice";
import { ISendQuote, sendQuote } from "../redux/apiActions/requestsAction";
import { useAppDispatch } from "../redux/hooks";

type Props = {
  record: RequestAtc;
  popup: any;
};

const SendQuotationForm: React.FC<Props> = ({ record, popup }: Props) => {
  const [form] = useForm();
  const dispatch = useAppDispatch();

  const onFinish = async (values: ISendQuote) => {
    await dispatch(sendQuote({ ...values, request_id: record?.id }));
    popup.close();
  };

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        initialValues={record}
        onFinish={onFinish}
      >
        <Row justify="center" style={{ marginTop: "30px" }}>
          <Col span={12}>
            <Form.Item label="Enter Amount" name="amount">
              <InputNumber
                placeholder="Enter amount"
                className="full-width"
                suffix="USD"
              />
            </Form.Item>

            <Flex justify={"center"}>
              <Form.Item>
                <Button
                  htmlType="submit"
                  ghost
                  // loading={loading.createExam || loading.updateExam}
                  // disabled={loading.createExam || loading.updateExam}
                >
                  Send Quotation
                </Button>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default SendQuotationForm;
